import moment from "moment";
import useDevices from "./useDevices";
import React, { useState } from "react";
import Spinner from "../../components/shared/spinner/Spinner";

const ManageDevices = () => {
  const { isCoach, loading, isCoachShowSuccess, devices, removeDevice } =
    useDevices();

  return (
    <div className="font-manrope max-w-2xl mx-auto p-4">
      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <Spinner color="primary500" size="md" />
        </div>
      ) : (
        <>
          {isCoach ? (
            <div className="flex justify-center items-center h-screen">
              {isCoachShowSuccess ? (
                <div className="text-primary500 text-center text-2xl font-semibold">
                  You successfully added the device!
                </div>
              ) : (
                <div className="text-error500 text-center text-2xl font-semibold">
                  Something went wrong, please try again.
                </div>
              )}
            </div>
          ) : (
            <>
              <div className="text-black text-lg font-bold mb-4">
                Device Management
              </div>

              {devices && devices?.length ? (
                <table className="rounded-xl overflow-hidden border border-gray200 border-collapse border-spacing-0 min-w-full">
                  <thead>
                    <tr className="bg-gray50 text-xs text-left text-gray600">
                      <th className="py-3 px-4">Device</th>
                      <th className="py-3 px-4">Last Active</th>
                      <th className="py-3 px-4">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {devices.map((device) => (
                      <tr
                        key={device?.deviceId}
                        className="border-t border-gray200"
                      >
                        <td className="px-3 py-4">
                          <div className="font-semibold text-xs text-gray900">
                            {device?.deviceName}
                          </div>
                        </td>
                        <td className="px-3 py-4">
                          <div className="font-semibold text-xs text-gray900">
                            {moment(device.lastActive).format("MM/DD/YYYY")}
                          </div>
                        </td>

                        <td className="px-3 py-4">
                          <button
                            onClick={() =>
                              removeDevice({ deviceId: device?.deviceId })
                            }
                            className="min-h-11 h-11 rounded-full font-semibold text-sm btnPrimary500"
                          >
                            {"Remove"}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="flex items-center gap-1 px-4 py-3 bg-gray50 rounded-xl">
                  <div className="text-gray900 text-sm font-semibold">
                    0 Devices
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ManageDevices;
